function calcDiscount(elem, mode, discount) {
  let span1 = elem.querySelector(".sticker-amount-value");
  let span2 = elem.querySelector(".sticker-amount-decimal");
  let span3 = elem.querySelector(".sticker-amount-type");

  const discArray = discount.toString().split(".");

  if (discArray[1] === "00") {
    span1.textContent = `-${discArray[0]}`;
    span2.textContent = ``;
  } else {
    span1.textContent = `-${discArray[0]},`;
    span2.textContent = `${discArray[1]}`;
  }

  span3.textContent = mode === "percentage" ? `%` : `€`;
}

function calcPrices() {
    const secondsElemNumb = document.querySelectorAll(`.discount-badge-amount .badge-sticker-amount`);

    secondsElemNumb.forEach((elem) => {
        const calcMode = elem.getAttribute("data-calc-mode");
        const showMode = elem.getAttribute("data-show-mode");
        const price = parseFloat(elem.getAttribute("data-price"));
        const discount = parseFloat(elem.getAttribute("data-discount"));

        if (isNaN(discount)) return;

        const priceWithDecimals = price / 100;

        if (showMode === "percentage") {
            if (calcMode === "percentage") {
              calcDiscount(elem, showMode, discount.toFixed(2));
            } else {
              const discountValue = (discount / priceWithDecimals) * 100;
              let discountValueTrunc = Math.trunc(discountValue * 100) / 100;
              calcDiscount(elem, showMode, discountValueTrunc.toFixed(2));
            }
        } else {
            if (calcMode === "percentage") {
              const discountValue = priceWithDecimals * (discount / 100);
              let discountValueTrunc = Math.trunc(discountValue * 100) / 100;
              calcDiscount(elem, showMode, discountValueTrunc.toFixed(2));
            } else {
              calcDiscount(elem, showMode, discount.toFixed(2));
            }
        }
    });
}

document.addEventListener("DOMContentLoaded", function() {
  calcPrices();
});
